import { Checkbox, FormControlLabel } from "@mui/material";
import { Field } from "formik";

// TODO: create a fastfield version
// when using in single mode the value will be default to false
// make every checkout has a value in the case of multiple checkbox
const CheckBoxInput = ({name, label, value=false, single, ...rest}) => {
    return (
        <Field
            type='checkbox'
            name={name}
            {...{rest}}
        >

            {({meta, form}) => {

                const handleChange = (e) => {
                    // used as a single checkbox
                    if (single) {
                        return form.setFieldValue(name, e.target.checked)
                    }
                    // used checkboxs with the same name
                    let checkBoxList = [...meta?.value];

                    if (!checkBoxList?.includes(value)) {
                        checkBoxList.push(value);
                        return form.setFieldValue(name, checkBoxList);
                    }
                    const itemToRemove = value;
                    checkBoxList = checkBoxList.filter(item => item !== itemToRemove);
                    form.setFieldValue(name, checkBoxList)
                }

                return(
                    <FormControlLabel
                        label={label}
                        control={
                            <Checkbox
                                name={name}
                                onChange={handleChange}
                                value={!single ? value : meta.value}
                                checked={!single ? meta?.value?.includes(value) : meta.value}
                            />
                        }
                    />

                );
            }}
        </Field>
    );
}

export default CheckBoxInput;